import './prev-next-nav.scss';

/**
 * version    1.0
 * class      <type> (PrevNextNav)
 * classdesc  Prev Next Nav: contains one nav tag with two navigation link (prev and next) over occhiello and title
 */
export class PrevNextNav {}
